export const getProductCommissionValue = (
  discountedPrice: number,
  fixedCommission = 0,
  commissionPercentage = 0
) => {
  return (
    fixedCommission ||
    Math.floor((discountedPrice * Number(commissionPercentage)) / 100)
  );
};
